<div class="d-flex flex-column align-items-center p-4 mt-5">
  <h5 class="page-title">404</h5>
  <h1>{{ apiTitles?.not_found_page_title }}</h1>
  <p>{{ apiTitles?.not_found_click }}</p>
  <button class="btn btn-primary" (click)="goToHome()" >{{ apiTitles?.not_found_home }}</button>
</div>
